import React, { FC } from 'react';
import classNames from 'classnames';

import { IconType } from '../icon.type';

const TriangleWarningIcon: FC<IconType> = (props) => {
  const { size, className, customStyle } = props;
  return (
    <div className={classNames(className)}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        style={customStyle}
        fill="none"
        viewBox="0 0 15 14"
      >
        <path
          fill="currentColor"
          d="M14.61 9.556 10.024 1.48A2.94 2.94 0 0 0 8.957.397a2.88 2.88 0 0 0-2.914 0c-.443.26-.81.634-1.067 1.084L.39 9.556a3 3 0 0 0 0 2.964c.256.45.624.824 1.067 1.084S2.403 14 2.914 14h9.172c.511 0 1.014-.136 1.457-.396s.81-.634 1.066-1.084a3 3 0 0 0 0-2.964m-2.524 3.171H2.914c-1.28 0-2.081-1.408-1.441-2.535l4.586-8.074a1.7 1.7 0 0 1 .61-.619 1.64 1.64 0 0 1 1.663 0c.253.149.463.362.61.62l4.585 8.073c.64 1.127-.16 2.535-1.441 2.535M7.5 9.552a.77.77 0 0 0-.434.134.809.809 0 0 0-.118 1.224.78.78 0 0 0 .851.172.8.8 0 0 0 .351-.293.805.805 0 0 0-.097-1.004.78.78 0 0 0-.553-.233m.547-4.763h-1.09a.39.39 0 0 0-.29.131.4.4 0 0 0-.1.307l.313 3.175a.4.4 0 0 0 .127.255.4.4 0 0 0 .262.103h.466c.096 0 .19-.037.262-.103a.4.4 0 0 0 .126-.255l.313-3.175a.4.4 0 0 0-.099-.307.4.4 0 0 0-.29-.13"
        ></path>
      </svg>
    </div>
  );
};

export default TriangleWarningIcon;
